module.exports = __webpack_public_path__ + "static/img/Walbing_icon.9249d8c6.svg";